"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
exports.__esModule = true;
exports.default = void 0;
var _changeDetails = _interopRequireDefault(require("../core/change-details.js"));
var _holder = _interopRequireDefault(require("../core/holder.js"));
var _pattern = _interopRequireDefault(require("./pattern.js"));
require("../core/utils.js");
require("./base.js");
require("../core/continuous-tail-details.js");
require("./factory.js");
require("./pattern/chunk-tail-details.js");
require("./pattern/cursor.js");
require("./pattern/fixed-definition.js");
require("./pattern/input-definition.js");
require("./regexp.js");
var _excluded = ["to", "from", "maxLength", "autofix"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/** Pattern which accepts ranges */
var MaskedRange = exports.default = /*#__PURE__*/function (_MaskedPattern) {
  function MaskedRange(opts) {
    _classCallCheck(this, MaskedRange);
    return _callSuper(this, MaskedRange, [opts]); // mask will be created in _update
  }
  _inherits(MaskedRange, _MaskedPattern);
  return _createClass(MaskedRange, [{
    key: "_matchFrom",
    get:
    /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
    */

    /** Min bound */

    /** Max bound */

    function get() {
      return this.maxLength - String(this.from).length;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      _superPropGet(MaskedRange, "updateOptions", this, 3)([opts]);
    }
  }, {
    key: "_update",
    value: function _update(opts) {
      var _opts$to = opts.to,
        to = _opts$to === void 0 ? this.to || 0 : _opts$to,
        _opts$from = opts.from,
        from = _opts$from === void 0 ? this.from || 0 : _opts$from,
        _opts$maxLength = opts.maxLength,
        maxLength = _opts$maxLength === void 0 ? this.maxLength || 0 : _opts$maxLength,
        _opts$autofix = opts.autofix,
        autofix = _opts$autofix === void 0 ? this.autofix : _opts$autofix,
        patternOpts = _objectWithoutProperties(opts, _excluded);
      this.to = to;
      this.from = from;
      this.maxLength = Math.max(String(to).length, maxLength);
      this.autofix = autofix;
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var sameCharsCount = 0;
      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
      patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
      _superPropGet(MaskedRange, "_update", this, 3)([patternOpts]);
    }
  }, {
    key: "isComplete",
    get: function get() {
      return _superPropGet(MaskedRange, "isComplete", this, 1) && Boolean(this.value);
    }
  }, {
    key: "boundaries",
    value: function boundaries(str) {
      var minstr = '';
      var maxstr = '';
      var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
        _ref2 = _slicedToArray(_ref, 3),
        placeholder = _ref2[1],
        num = _ref2[2];
      if (num) {
        minstr = '0'.repeat(placeholder.length) + num;
        maxstr = '9'.repeat(placeholder.length) + num;
      }
      minstr = minstr.padEnd(this.maxLength, '0');
      maxstr = maxstr.padEnd(this.maxLength, '9');
      return [minstr, maxstr];
    }
  }, {
    key: "doPrepareChar",
    value: function doPrepareChar(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      var details;
      var _superPropGet2 = _superPropGet(MaskedRange, "doPrepareChar", this, 3)([ch.replace(/\D/g, ''), flags]);
      var _superPropGet3 = _slicedToArray(_superPropGet2, 2);
      ch = _superPropGet3[0];
      details = _superPropGet3[1];
      if (!ch) details.skip = !this.isComplete;
      return [ch, details];
    }
  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch, flags) {
      if (flags === void 0) {
        flags = {};
      }
      if (!this.autofix || this.value.length + 1 > this.maxLength) return _superPropGet(MaskedRange, "_appendCharRaw", this, 3)([ch, flags]);
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var _this$boundaries = this.boundaries(this.value + ch),
        _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
        minstr = _this$boundaries2[0],
        maxstr = _this$boundaries2[1];
      if (Number(maxstr) < this.from) return _superPropGet(MaskedRange, "_appendCharRaw", this, 3)([fromStr[this.value.length], flags]);
      if (Number(minstr) > this.to) {
        if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) {
          return _superPropGet(MaskedRange, "_appendCharRaw", this, 3)([fromStr[this.value.length], flags]).aggregate(this._appendCharRaw(ch, flags));
        }
        return _superPropGet(MaskedRange, "_appendCharRaw", this, 3)([toStr[this.value.length], flags]);
      }
      return _superPropGet(MaskedRange, "_appendCharRaw", this, 3)([ch, flags]);
    }
  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var str = this.value;
      var firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
      var _this$boundaries3 = this.boundaries(str),
        _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
        minstr = _this$boundaries4[0],
        maxstr = _this$boundaries4[1];
      return this.from <= Number(maxstr) && Number(minstr) <= this.to && _superPropGet(MaskedRange, "doValidate", this, 3)([flags]);
    }
  }, {
    key: "pad",
    value: function pad(flags) {
      var _this = this;
      var details = new _changeDetails.default();
      if (this.value.length === this.maxLength) return details;
      var value = this.value;
      var padLength = this.maxLength - this.value.length;
      if (padLength) {
        this.reset();
        for (var i = 0; i < padLength; ++i) {
          details.aggregate(_superPropGet(MaskedRange, "_appendCharRaw", this, 3)(['0', flags]));
        }

        // append tail
        value.split('').forEach(function (ch) {
          return _this._appendCharRaw(ch);
        });
      }
      return details;
    }
  }]);
}(_pattern.default);
_holder.default.MaskedRange = MaskedRange;